// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleWell_root__RfWFp","borderBottom":"ArticleWell_borderBottom__2csLw"};